import {
  getSchedule,
  getParticipantsEvent,
} from "../../../utils/services/schedule";
import { getAllSpeakers } from "../../../utils/services/speaker";

export const excelColumnsPtBr = {
  // EventoID: "eventId",
  Nome: "name",
  EmpresaCargoEspecialidade: "position",
  Categoria: "category",
  Foto: "photo",
  Sobre: "about",
  Facebook: "facebook",
  Instagram: "instagram",
  LinkedIn: "linkedin",
  WhatsApp: "whatsApp",
  Site: "site",
  Cor: "color",
  Ordem: "order",
  Agendas: "agendas",
};
export const excelColumnsUpdatePtBr = {
  // EventoID: "eventId",
  PalestranteID: "id",
  Nome: "name",
  EmpresaCargoEspecialidade: "position",
  Categoria: "category",
  Foto: "photo",
  Sobre: "about",
  Facebook: "facebook",
  Instagram: "instagram",
  LinkedIn: "linkedin",
  WhatsApp: "whatsApp",
  Site: "site",
  Cor: "color",
  Ordem: "order",
  Agendas: "agendas",
};

export const excelColumnsDeletePtBr = {
  PalestranteID: "id",
  Nome: "name",
};
export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    // eventId: row.eventId ? row.eventId : "",
    name: row.name ? row.name : undefined,
    position: row.position ? row.position : "",
    category: row.category ? row.category : "",
    photo: row.photo ? row.photo : "",
    about: row.about ? row.about : "",
    facebook: row.facebook ? row.facebook : "",
    instagram: row.instagram ? row.instagram : "",
    linkedin: row.linkedin ? row.linkedin : "",
    whatsApp: row.whatsApp ? row.whatsApp : "",
    site: row.site ? row.site : "",
    color: row.color ? row.color : "",
    order: row.order ? row.order : "",
    agendas: row.agendas ? row.agendas : [],
  };

  return formatedRow;
}

export function allExcelColumnsUpdate(row, index) {
  const formatedRow = {
    index,
    // eventId: row.eventId ? row.eventId : "",
    id: row.id ? row.id : undefined,
    name: row.name ? row.name : undefined,
    position: row.position ? row.position : "",
    category: row.category ? row.category : "",
    photo: row.photo ? row.photo : "",
    about: row.about ? row.about : "",
    facebook: row.facebook ? row.facebook : "",
    instagram: row.instagram ? row.instagram : "",
    linkedin: row.linkedin ? row.linkedin : "",
    whatsApp: row.whatsApp ? row.whatsApp : "",
    site: row.site ? row.site : "",
    color: row.color ? row.color : "",
    order: row.order ? row.order : "",
    agendas: row.agendas ? row.agendas : [],
  };

  return formatedRow;
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    index,
    id: row.id ? row.id : undefined,
    name: row.name ? row.name : undefined,
  };

  return formatedRow;
}

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export function findRowsWithError(validRows) {
  const rowsWithError = validRows.filter(
    (row) =>
      Object.values(row).filter((value) => value === undefined).length > 0
  );
  return rowsWithError;
}

function hasValidProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export async function getValidateSpeaker(file, eventId, importType) {
  const limit = 9999;

  const getAgendas = await getSchedule({
    id: eventId,
    jwt: "",
    offset: 1,
    limit: limit,
    search: "",
  });
  const agendasIds = getAgendas?.agenda?.data?.map((e) => e.id);

  const getSpeakers = await getAllSpeakers(eventId, 1, limit, "", "");

  const speakersIds = getSpeakers?.data?.findAllPalestrantes?.data?.map(
    (e) => e.id
  );

  const erros = [];

  file.forEach((item, index) => {
    const error = { index };

    if (!item.name || item.name.trim() === "") {
      error.name = undefined;
    }

    if (importType !== "create") {
      const speakerId = item?.id;

      if (typeof speakerId !== "string" || speakerId.trim() === "") {
        error.id = undefined;
        error.invalidId = null;
      } else {
        const invalidId = !speakersIds.includes(speakerId);

        if (invalidId) {
          error.id = undefined;
          error.invalidId = speakerId;
        }
      }
    }
    const agendasStr = item.agendas;

    if (importType !== "delete") {
      if (typeof agendasStr !== "string" || agendasStr.trim() === "") {
        // error.agendas = undefined;
      } else {
        const ids = agendasStr.split(",").map((id) => id.trim());
        const invalidIds = ids.filter((id) => !agendasIds.includes(id));

        if (invalidIds.length > 0) {
          error.agendas = undefined;
          error.invalidAgendas = invalidIds;
        }
      }
    }

    if (
      (hasValidProperty(error, "name") && error.name === undefined) ||
      (hasValidProperty(error, "agendas") && error.agendas === undefined) ||
      (hasValidProperty(error, "id") && error.id === undefined)
    ) {
      erros.push(error);
    }
  });

  return erros;
}
